import * as angular from 'angular';

import { ILoggerService } from '../../services';
import { GaugeOptions } from '../../framework/charting/charts/Gauge/GaugeOptions';
import { GaugeDataFormat } from '../../framework/charting/charts/Gauge/GaugeDataFormat';
import { groupSelected, refreshClick } from '../../common/';
import { Group, ErrorLevel } from '../../models/index';
import { IGauge } from './IGauge';

export class GaugeBase implements IGauge {

    id: string;
    value: number;
    options: GaugeOptions;
    isLoading: boolean;
    data: GaugeDataFormat[];

    item: any;
    tagDefinitionGuid: string;
    isTagMode: boolean;
    isGroupMode: boolean;

    progressBarClass: string;
    private _guid: string;

    constructor(private _$scope: angular.IScope,
        private _loggerService: ILoggerService) {

    }

    $onInit() {
        this.id = `id${this.item.guid}`;
        this.data = [{
            value: 0,
            format: '.0%',
            bands: this.item.options.bands
        }];
        this.tagDefinitionGuid = this.item.tagDefinitionGuid;
        this.isTagMode = this.item.isTagMode;
        this.isGroupMode = this.item.isGroupMode;
        this.options = {
            ticksCount: 6,
            labelsCount: 6,
            thickness: .25,
            range: [-2 * Math.PI / 3, 2 * Math.PI / 3],
            tickSize: 5,
            isTitleVisible: false,
            isLegendVisible: false,
            title: '',
            showTarget: false
        };

        this._$scope.$on(groupSelected, this.groupSelected());
        this._$scope.$on(refreshClick, () => {
            this.readData(this._guid);
        });

        this.readData(this._guid);
    }

    private groupSelected() {
        const self = this;
        return (event, group: Group) => {
            self._guid = group.guid;
            self.readData(self._guid);
        };
    }

    private refresh() {
        const self = this;
        return (event?, data?) => {
            self.readData(self._guid);
        };
    }

    readData(guid?: string): void {
        const self = this;
        this.isLoading = true;
        self.progressBarClass = '';
        try {
            this.item
                .readData(guid)
                .then((response) => {
                    const d0 = this.data[0];
                    d0.value = response;
                    this.data = [d0];
                    //self.value = response;
                    self.item
                        .getErrorLevelAsync()
                        .then(error => {
                            if (error.level === ErrorLevel.Error) {
                                self.progressBarClass = 'progress-bar-danger';
                            } else if (error.level === ErrorLevel.Warning) {
                                self.progressBarClass = 'progress-bar-warning';
                            } else {
                                self.progressBarClass = 'progress-bar-success';
                            }
                        });
                    self.isLoading = false;
                }, (reason) => {
                    self._loggerService.logError(reason);
                    self.isLoading = false;
                })
                .finally(() => {
                    self.isLoading = false;
                });
        } catch (e) {
            this._loggerService.logError(e);
            this.isLoading = false;
        }
    }
}